import { Navigate, Outlet, useLocation } from "react-router";
import { MainProgressBarEnum } from "../enums/mainProgressBarEnum";
import store, { useTypedSelector } from "../store";
import {
    selectCurrentStep,
    selectNextStep,
    setProgressBarStep,
} from "../../features/mainProgressBar/mainProgressBarSlice";
import { mapStepToRoute } from "../../services/routes/progressRouteStepMapper";
import { useEffect } from "react";

interface Props {
    expectedStep: MainProgressBarEnum;
}

export const ProgressBarOutlet = ({ expectedStep }: Props) => {
    const currentStep = useTypedSelector(selectCurrentStep);
    const nextStep = useTypedSelector(selectNextStep);
    const { pathname } = useLocation();

    useEffect(() => {
        if (
            (expectedStep === nextStep && expectedStep !== currentStep) ||
            (expectedStep < nextStep && expectedStep < currentStep)
        ) {
            store.dispatch(setProgressBarStep({ currentStep: expectedStep, nextStep: expectedStep }));
        }
    }, [expectedStep, nextStep, currentStep]);

    if (
        (expectedStep === nextStep && expectedStep === currentStep) ||
        (expectedStep < nextStep && expectedStep < currentStep) ||
        (expectedStep === nextStep && expectedStep !== currentStep) ||
        (expectedStep < nextStep && expectedStep === currentStep)
    ) {
        return <Outlet />;
    } else {
        return <Navigate to={mapStepToRoute(currentStep)} state={{ from: pathname }} replace={true} />;
    }
};
